import { render, staticRenderFns } from "./taskDialog.vue?vue&type=template&id=dbaffb44&scoped=true&"
import script from "./taskDialog.vue?vue&type=script&lang=js&"
export * from "./taskDialog.vue?vue&type=script&lang=js&"
import style0 from "./taskDialog.vue?vue&type=style&index=0&id=dbaffb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbaffb44",
  null
  
)

export default component.exports